export const REGISTERS = {
    A: 0,
    AL: 1,
    B: 2,
    BL: 3,
    C: 4,
    CL: 5,
    D: 6,
    DL: 7,
    X: 8,
    XL: 9,
    Y: 10,
    YL: 11,
    BP: 12,
    BPL: 13,
    SP: 14,
    SPL: 15
};

export const REGISTER_NAMES = Object.entries(REGISTERS).reduce((o, [k, v]) => (o[v] = k, o), {});

export const FLAGS = {
    ZERO: 0,
    OVERFLOW: 1,
    CARRY: 2,
    NEGATIVE: 3,
    SINGLE_STEP: 4,
    INTERRUPT_SERVICE: 5,
    INTERRUPT_DISABLE: 6,
    EXCEPTION: 7,
};
export const FLAG_NAMES = [ "Z", "V", "C", "N", "SS", "IS", "ID", "EX" ];

export const OPCODES = {
    NOP: "nop",
    ADD: "add",
    AND: "and",
    CMP: "cmp",
    SUB: "sub",
    OR:  "or",
    TEST:"test",
    XOR: "xor",
    TRAP:"trap",
    NOT: "not",
    NEG: "neg",
    EXC: "exc",
    SHL: "shl",
    SHR: "shr",
    SWAP: "swap",
    MOV: "mov",
    LD: "ld",
    ST: "st",
    INC: "inc",
    IN: "in",
    OUT: "out",
    ENTER: "enter",
    EXIT: "exit",
    BRK: "brk",
    LOOP: "loop", LOOPS: "loops",
    BR: "br", BRS: "brs",
    CALL: "call", CALLS: "calls",
    PUSHALL: "pushall",
    POPALL: "popall",
    PUSHF: "pushf",
    POPF: "popf",
    PUSHMM: "pushmm",
    POPMM: "popmm",
    PUSH: "push",
    POP: "pop",
    RET: "ret",
    MUL: "mul",
    MOD: "mod",
    DIV: "div",
    SMUL: "smul",
    SMOD: "smod",
    SDIV: "sdiv",
    SET: "set",
    CLR: "clr",
    DEC: "dec",
    HALT: "halt",
    WAIT: "wait",
        FCLR:   "fclr",
        FLDR:   "fldr",
        FLDM:   "fldm",
        FLDIM:  "fldim",
        FSTR:   "fstr",
        FSTM:   "fstm",
        FSTIM:  "fstim",
        FADD:   "fadd",
        FSUB:   "fsub",
        FCMP:   "fcmp",
        FMUL:   "fmul",
        FDIV:   "fdiv",
        FMOD:   "fmod",
        FPOW:   "fpow",
        FSQRT:  "fsqrt",
        FABS:   "fabs",
        FSIN:   "fsin",
        FCOS:   "fcos",
        FTAN:   "ftan",
        FASIN:  "fasin",
        FACOS:  "facos",
        FATAN:  "fatan",
        FNEG:   "fneg",
        FEXC:   "fexc",
        FINT:   "fint",
        FISNAN: "fisnan",
        FISINF: "fisinf",
        FLOG2:  "flog2",
        FLOG10: "flog10",
        FLD0:   "fld0",
        FLD1:   "fld1",
        FLDE:   "flde",
        FLDPI:  "fldpi",
};

export const DIRECTIVES = {
    SEGMENT: ".segment",
    BYTE: ".byte",
    WORD: ".word",
    STRING: ".string",
    APPEND: ".append",
    CONST: ".const",
    IMPORT: ".import",
    MACRO: ".macro",
    DEFINE: ".define",
};

export const TOKENS = {
    COMMENT: "comment",
    STRING: "string",
    INTEGER: "integer",
    IDENTIFIER: "identifier",
    REGISTER: "register",
    FLAG: "flag",
    EXPRESSION: "expression",
    BINARY_EXPRESSION: "binary.expression",
    UNARY_EXPRESSION: "unary.expression",
    INSTRUCTION: "instruction",
    SEGMENT_DIRECTIVE: "directive.segment",
    NAMESPACE_DIRECTIVE: "directive.namespace",
    CONST_DIRECTIVE: "directive.const",
    IMPORT_DIRECTIVE: "directive.import",
    BYTE_DIRECTIVE: "directive.byte",
    WORD_DIRECTIVE: "directive.word",
    STRING_DIRECTIVE: "directive.string",
    LABEL: "label",
    MEMORY: "memory",
    BLOCK: "block",
    FUNCTION: "function",
    MACRO_DIRECTIVE: "directive.macro",
    MACRO_EXPANSION: "expand.macro",
    CONDITIONAL: "conditional"
};

export const MODES = {
    IMMEDIATE: 0b00,
    ABSOLUTE: 0b01,
    BP: 0b10,
    D: 0b11
};